var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#DC3545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_11621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5593 18.0677V11.6837H19.2293V18.0677C19.2293 18.9637 19.0053 19.645 18.5573 20.1117C18.1186 20.569 17.4746 20.7977 16.6253 20.7977C15.7293 20.7977 15.0433 20.569 14.5673 20.1117C14.0913 19.645 13.8533 18.9637 13.8533 18.0677V11.6837H12.5233V18.0677C12.5233 19.4024 12.8826 20.3777 13.6013 20.9937C14.3293 21.6004 15.3373 21.9037 16.6253 21.9037C17.8853 21.9037 18.856 21.5864 19.5373 20.9517C20.2186 20.3077 20.5593 19.3464 20.5593 18.0677Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_11621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.539062 0.679688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon3);
export default __webpack_public_path__ + "static/media/user_icon_3.92b851610c16c7206edee94cb25b941c.svg";
export { ForwardRef as ReactComponent };